import { CompoundComponentsMap } from './types';

export const createCompoundComponent = <T, C extends CompoundComponentsMap>(Root: React.FC<T>, compound: C) =>
  Object.assign(Root, compound);
